import { useCourseExerciseHook } from '../../hooks/courseExercise';

import { Fragment, useEffect, useState } from 'react';
import Confetti from 'react-confetti';
import Exercise from '../../../../core/components/templates/Exercise';
import { useUserStore } from '../../../Auth/stores/authStore';
import { useLocation } from 'react-router-dom';
import NoContent from '../../../../core/components/templates/NoContent';
import { PopUpModal } from '../../../Gamification/components/Playing/PopUpModal';
import { ExerciseAction, IExercise } from '../../../../core/models/exercise';
import { useShouldShowPopUpScore } from '../../../../core/hooks/useShouldShowPopUpScore';

interface CourseExercisesProps {
  setContentAsDone: () => Promise<void>;
}

const CourseExercises = ({ setContentAsDone }: CourseExercisesProps) => {
  const { user } = useUserStore();
  const { pathname } = useLocation();

  const {
    title,
    isLoading,
    exercises,
    discipline,
    isRight,
    changeExercise,
    updateExercise,
  } = useCourseExerciseHook({ setContentAsDone });
  const { shouldShowPopUpScore } = useShouldShowPopUpScore();

  const [showModalScore, setShowModalScore] = useState<number | false>(false);
  const [action, setAction] = useState<ExerciseAction | undefined>(undefined);

  useEffect(() => {
    if (isRight) {
      const audio = new Audio(
        'https://storage.aprovatotal.com.br/platform-storage-prod/sounds/songCorrectExercise.mp3'
      );

      if (user && user.exercisePlaySound) {
        audio.play();
      }
    }

    if (action === 'verifyAnswer' && shouldShowPopUpScore) {
      setShowModalScore(isRight ? 2 : 1);
    }
    setAction(undefined);
  }, [isRight, action, shouldShowPopUpScore]);

  const handleExerciseChange = (
    exercise: IExercise,
    action?: ExerciseAction
  ) => {
    setAction(action);
    updateExercise(exercise, action);
  };

  if (!exercises) {
    const url = `${pathname}/detalhes`;

    return <NoContent url={url} />;
  }

  return (
    <Fragment>
      {isRight && user?.exerciseShowAnimation && (
        <Confetti
          width={window.innerWidth - 20}
          height={document.body.clientHeight}
          numberOfPieces={300}
        />
      )}
      <Exercise
        title={title}
        discipline={discipline}
        exercises={exercises}
        isLoading={isLoading}
        onPageChange={(page) => changeExercise(page)}
        onExerciseChange={(exercise, action) => {
          handleExerciseChange(exercise, action);
        }}
      />
      {showModalScore && (
        <PopUpModal
          isOpen={!!showModalScore}
          onClose={() => setShowModalScore(false)}
          score={showModalScore}
        />
      )}
    </Fragment>
  );
};

export default CourseExercises;
